export enum FlowType {
    NEWTAB = 'NEWTAB',
    SAMETAB = 'SAMETAB'
}